import React from 'react';
import { useRecoilState } from 'recoil';
import { SelectionGroup, SelectionGroupItem } from 'fronton-react';
import { SelectionGroupValue } from 'fronton-react/selection-group/types';
import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { savedConfigurationCalculationState } from 'pages/saved-project-configuration/store/calculation';
import { TProductVariant } from 'pages/saved-project-configuration/types';
import { getVariantText } from '../../helpers/get-variant-text';
import { getUpdatedComplementaryGroups } from '../../helpers/get-updated-complementary-groups';
import { variantsSelectionGroup } from './styles';

type TProps = {
  variants: TProductVariant[];
  productId: string;
  groupName: string;
};

export const ComplementaryGroupVariants = ({ variants, productId, groupName }: TProps) => {
  const [calculationState, setCalculationState] = useRecoilState(savedConfigurationCalculationState);
  const { checkedProducts, complimentaryGroups } = calculationState;

  const currentGroup = complimentaryGroups.find(group => group.groupName === groupName);
  const selectedValue = currentGroup?.selectedVariantProductId;

  const handleChange = (_: React.MouseEvent<Element, MouseEvent>, value: SelectionGroupValue) => {
    const variantProductId = String(value);
    const isProductChecked = getIsCheckedProducts({ checkedProducts, productId }) ?? false;
    const selectedVariant = variants.find(variant => variant.productId === variantProductId);

    if (!selectedVariant || currentGroup?.selectedVariantProductId === variantProductId) return;

    setCalculationState(prevState => {
      const updatedGroups = getUpdatedComplementaryGroups({
        complimentaryGroups: prevState.complimentaryGroups,
        variantProductId,
        selectedVariant,
        groupName,
      });

      const updatedCheckedProducts = prevState.checkedProducts.map(item => {
        if (item.id === variantProductId) {
          return { ...item, isChecked: isProductChecked };
        }
        return item;
      });

      return {
        ...prevState,
        complimentaryGroups: updatedGroups,
        checkedProducts: updatedCheckedProducts,
      };
    });
  };

  return (
    <SelectionGroup
      className={variantsSelectionGroup}
      active={selectedValue as SelectionGroupValue}
      onChange={handleChange}
      size="m"
      variant="outline">
      {variants.map(variant => (
        <SelectionGroupItem value={variant.productId} key={variant.productId}>
          {getVariantText(variant)}
        </SelectionGroupItem>
      ))}
    </SelectionGroup>
  );
};
